export default __webpack_public_path__ + "static/media/Nationals.6a008eba.png";